import cookie from "js-cookie"

const segmentTypes = ["member", "nonmember", "lapsedmember"] as const
const cookieName = "user_segment"
type UserSegmentType = (typeof segmentTypes)[number]

export const setUserSegment = (segment: UserSegmentType): void => {
  cookie.remove(cookieName) // this will remove any existing 'session' cookie
  cookie.set(cookieName, segment, { expires: 30 })
}

export const getUserSegment = (): UserSegmentType => {
  const segment = cookie.get(cookieName)
  const result = segmentTypes.find((item) => segment === item)
  if (result) return result
  return "nonmember"
}

export const initUserSegment = (): void => {
  const segment = cookie.get(cookieName)
  const result = segmentTypes.find((item) => segment === item)
  if (result) return
  setUserSegment("nonmember")
}
